import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Logout, PingSuccess } from '@app/state/app-state/actions';
import { tap } from 'rxjs/operators';
import { EnvironmentService } from '@core/environment/services/environment.service';
import { Store } from '@ngrx/store';
import { getUser } from '@app/state/app-state/selectors';
import { IntercomService } from '../services/intercom.service';

@Injectable({ providedIn: 'root' })
export class IntercomEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private intercomService: IntercomService,
    private environmentService: EnvironmentService
  ) {}

  boot$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PingSuccess),
        concatLatestFrom(() => this.store.select(getUser)),
        tap(([, { email, userId }]) =>
          this.intercomService.boot({
            app_id: this.environmentService.intercomAppId,
            user_id: userId,
            email,
          })
        )
      ),
    { dispatch: false }
  );

  shutdown$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(Logout),
        tap(() => this.intercomService.shutdown())
      ),
    { dispatch: false }
  );
}
